var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('span',{staticClass:"time"},[_vm._v("["+_vm._s(_vm.timeRepresentation)+"]")]),_vm._v(" "),_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.message.author)+": ")]),_vm._v(" "),_c('span',{staticClass:"content",domProps:{"textContent":_vm._s(_vm.message.content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ChatListElement.vue?vue&type=template&id=a78da798&scoped=true
// module id = i+oG
// module chunks = 1